import React from 'react'
import * as scroll from 'react-scroll'
import {Link} from 'react-dom'
function Menu() {
  return (
    <ul id='Menu'  className='hidden md:flex justify-between'>
    <li className='m-4 font-primary text-white font-bold text-3xl'><a href="">
    <scroll.Link
      to='Skills'
      smooth={true}
      offset={-400}
      >Skills</scroll.Link>  
    </a></li>
    <li className='m-4 font-primary text-white font-bold text-3xl'><a href="">
      <scroll.Link
      to='portfolio'
      smooth={true}
      offset={-300}
      >portfolio</scroll.Link>
      </a></li>
    <li className='m-4 font-primary text-white font-bold text-3xl'><a href="">
    <scroll.Link
      to='Contact'
      smooth={true}
      duration={1500}
      offset={-100}
      >contact us</scroll.Link>
      </a></li>
  </ul>  
  )
}

export default Menu